export const gravityLockData = [
  {
    Question: `What is a Gravity Lock?`,
    Answer: `A Gravity Lock is a dumpster with an accompanying bar that is to remain in the locked position when servicing the dumpster. Gravity releases the lock when the dumpster is being tipped over during service. The gravity lock is designed to be used in combination with a padlock lock you provide. Watch the video on our page for more details.`,
  },
]
